import PropTypes from 'prop-types';
import { linkType } from './link';
import { responsiveImageType } from './image';

export const tileShape = {
  clickthrough: linkType,
  image: responsiveImageType,
  title: PropTypes.string,
};

export const tileDefaultProps = {
  image: undefined,
  title: undefined,
};

export const tileType = PropTypes.shape(tileShape);
